import { Fade, Stack, StackProps } from "@mui/material";

import { layoutClasses } from "./Layout";

export interface BodyProps extends StackProps {}

export const Body: React.FC<BodyProps> = ({
  children,
  className,
  sx,
  ...props
}) => {
  return (
    <Stack
      className={`${layoutClasses.body} ${layoutClasses.stack} ${className}`}
      sx={{ justifyContent: "space-between", ...sx }}
      {...props}
    >
      <Fade in mountOnEnter unmountOnExit>
        <Stack
          className={layoutClasses.stack}
          sx={{ justifyContent: "stretch" }}
        >
          {children}
        </Stack>
      </Fade>
    </Stack>
  );
};
